/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import AuthService from "./AuthService";

class EmailService {
    constructor() {
        this.apiUrl = process.env.REACT_APP_API_URL || "https://portalrelacionamentoapi.dev-gam.com"; // URL base da API
    }

    async atualizarEmails(cdCliente, emails) {
        try {
            console.log('EmailService: Iniciando atualização de emails');
            console.log('EmailService: Cliente:', cdCliente);
            console.log('EmailService: Emails a atualizar:', emails);

            const normalizado = {
                compradorMedicamento:
                    emails.compradorMedicamento || emails["comprador medicamento"],
                compradorPerfumaria:
                    emails.compradorPerfumaria || emails["comprador perfumaria"]
            }


            if (!AuthService.getToken()) {
                await AuthService.login();
            }

            const payload = [];

            console.log("email", emails);

            // Verifica se ÃÂ© uma atualizaÃÂ§ÃÂ£o de email individual
            if (emails.gestor) {
                console.log('EmailService: Atualizando email GESTOR:', emails.gestor);
                payload.push({
                    cdCategoriaEmail: 11, // GESTOR
                    dsEmail: emails.gestor.trim(),
                    nmResponsavel: emails.nmResponsavel || "Responsável não informado",
                });
            }

            if (normalizado.compradorMedicamento) {
                console.log("compradorMedicamento:", normalizado.compradorMedicamento);
                payload.push({
                    cdCategoriaEmail: 12, // COMPRADOR MEDICAMENTO
                    dsEmail: normalizado.compradorMedicamento.trim(),
                    nmResponsavel: emails.nmResponsavel || "Responsável não informado",
                });
            } else {
                console.log("compradorMedicamento não informado ou inválido");
            }

            if (normalizado.compradorPerfumaria) {
                console.log("compradorPerfumaria:", normalizado.compradorPerfumaria);
                payload.push({
                    cdCategoriaEmail: 32, // COMPRADOR PERFUMARIA
                    dsEmail: normalizado.compradorPerfumaria.trim(),
                    nmResponsavel: emails.nmResponsavel || "Responsável não informado",
                });
            } else {
                console.log("compradorPerfumaria não informado ou inválido");
            }

            // Verifica se ÃÂ© uma atualizaÃÂ§ÃÂ£o de emails NFE/Boleto (mantÃÂ©m compatibilidade)
            const principal = emails.principal ? emails.principal.trim() : "";
            const copia = emails.copia ? emails.copia.trim() : "";
            const boleto = emails.boleto ? emails.boleto.trim() : "";

            if (principal !== "") {
                payload.push({
                    cdCategoriaEmail: 1, // NFE PRINCIPAL
                    dsEmail: principal,
                    nmResponsavel: emails.nmResponsavel || "Responsável não informado",
                });
            }

            if (copia !== "") {
                payload.push({
                    cdCategoriaEmail: 2, // NFE CÃÂPIA
                    dsEmail: copia,
                    nmResponsavel: emails.nmResponsavel || "Responsável não informado",
                });
            }

            if (boleto !== "") {
                payload.push({
                    cdCategoriaEmail: 43, // BOLETO DIGITAL
                    dsEmail: boleto,
                    nmResponsavel: emails.nmResponsavel || "Responsável não informado",
                });
            }

            if (payload.length === 0) {
                throw new Error("Nenhum email foi alterado.");
            }

            console.log('EmailService: Payload a ser enviado:', payload);
            console.log('EmailService: Payload detalhado:', JSON.stringify(payload, null, 2));

            const response = await axios.post(
                `${this.apiUrl}/cliente/alterar-email/${cdCliente}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${AuthService.getActiveToken()}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log('EmailService: Resposta da API:', response.data);
            return response.data;
        } catch (error) {
            console.error("Erro ao atualizar emails:", error);
            throw new Error("Erro ao atualizar emails.");
        }
    }
}

export default new EmailService();
